import { SeverityDisruptionFactorType } from 'client/dto';
import { Typography } from 'components/_common/Typography';
import React from 'react';

type SeveritySummaryProps = {
  severity: SeverityDisruptionFactorType;
  diseaseName: string;
};

const SeveritySummary: React.FC<SeveritySummaryProps> = ({ severity, diseaseName }) => {
  switch (severity) {
    case SeverityDisruptionFactorType.Severe: {
      return (
        <div data-testid="severity-summary">
          {diseaseName} can
          <Typography variant="subtitle1" inline>
            {' '}
            frequently lead to long term complications, hospitalization or death
          </Typography>
        </div>
      );
    }
    case SeverityDisruptionFactorType.ModerateToSevere: {
      return (
        <div data-testid="severity-summary">
          {diseaseName} can
          <Typography variant="subtitle1" inline>
            {' '}
            sometimes lead to long term complications, hospitalization or death
          </Typography>
        </div>
      );
    }
    case SeverityDisruptionFactorType.Moderate: {
      return (
        <div data-testid="severity-summary">
          {diseaseName} can
          <Typography variant="subtitle1" inline>
            {' '}
            sometimes lead to long term complications or hospitalization
          </Typography>
        </div>
      );
    }
    default: {
      return null;
    }
  }
};

export default SeveritySummary;
